import { Component, HostListener, OnInit } from '@angular/core';
import { StepService } from '../step.service';

@Component({
  selector: 'app-prev-btn',
  templateUrl: './prev-btn.component.html',
  styleUrls: ['./prev-btn.component.scss']
})
export class PrevBtnComponent implements OnInit {

  constructor(
    private stepService: StepService
  ) { }

  ngOnInit(): void {
  }


  @HostListener('click') onClick() {
    this.stepService.prevStep();
  }

}
